import type { ValueTypeEntry } from "../index";
import { DocumentCell } from "./document-cell";
import {
  resolveDocumentDisplayName,
  type DocumentOptions,
  type DocumentValue,
} from "./document-helpers";

export type { DocumentOptions } from "./document-helpers";
export { guessContentTypeFromFilename } from "./document-helpers";

/**
 * Built-in `document` field type. Filename display routes through
 * `displayFileNameFromObjectKey` — never duplicate the prefix-stripping
 * regex. The renderer composes an icon + middle-truncated name + click
 * button without depending on `@quovy/ui` (which depends on this
 * package). Documents are not inline-editable; `edit` returns `render`.
 */
export const documentType: ValueTypeEntry<DocumentValue, DocumentOptions> = {
  name: "document",
  format(value, options) {
    return resolveDocumentDisplayName(value, options);
  },
  render({ value, options }) {
    return <DocumentCell value={value} options={options ?? {}} />;
  },
  display({ value, options }) {
    const narrowed: DocumentValue = typeof value === "string" ? value : null;
    return <DocumentCell value={narrowed} options={options ?? {}} />;
  },
  edit(props) {
    return <DocumentCell value={props.value} options={props.options ?? {}} />;
  },
};
